module.exports = __webpack_public_path__ + "static/img/newsoo.932633a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsoo.jpg
// module id = IYi5
// module chunks = 45